package team.platforma.chatdata.table

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MokChatQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> observeChats(
    aiModelId: Long,
    userId: Long,
    mapper: (
      id: Long,
      aiModelId: Long,
      userId: Long,
      name: String,
    ) -> T,
  ): Query<T> = ObserveChatsQuery(aiModelId, userId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!
    )
  }

  public fun observeChats(aiModelId: Long, userId: Long): Query<MokChat> = observeChats(aiModelId,
      userId) { id, aiModelId_, userId_, name ->
    MokChat(
      id,
      aiModelId_,
      userId_,
      name
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertChat(
    id: Long?,
    aiModelId: Long,
    userId: Long,
    name: String,
  ): Long {
    val result = driver.execute(-1_745_817_927, """
        |INSERT INTO MokChat (id,aiModelId, userId,name)
        |VALUES (?, ?, ?,?)
        """.trimMargin(), 4) {
          bindLong(0, id)
          bindLong(1, aiModelId)
          bindLong(2, userId)
          bindString(3, name)
        }.await()
    notifyQueries(-1_745_817_927) { emit ->
      emit("MokChat")
    }
    return result
  }

  private inner class ObserveChatsQuery<out T : Any>(
    public val aiModelId: Long,
    public val userId: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("MokChat", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("MokChat", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(883_715_943, """
    |SELECT MokChat.id, MokChat.aiModelId, MokChat.userId, MokChat.name
    |FROM MokChat
    |WHERE aiModelId = ? AND userId = ?
    """.trimMargin(), mapper, 2) {
      bindLong(0, aiModelId)
      bindLong(1, userId)
    }

    override fun toString(): String = "MokChat.sq:observeChats"
  }
}
